import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { MotionPathPlugin } from "gsap/all";
import { Container, Graphics, Point, Sprite, Texture } from "pixi.js";
import gsap from "gsap";
export class DebugPath extends Container {
    static attach(tween) {
        const debugPath = new DebugPath(tween);
        tween.targets()[0].parent.addChild(debugPath);
        return tween;
    }
    constructor(tween) {
        super();
        this.tween = tween;
        this.points = [];
        this.line = this._createPath();
        const motionPathData = tween.vars.motionPath;
        if (typeof motionPathData === "object" && "path" in motionPathData) {
            this.initialData = motionPathData;
            const pointsData = this.initialData.path;
            this.curviness = this.initialData.curviness;
            this._drawPoints(pointsData);
            this._drawLine(pointsData, this.initialData.curviness);
        }
        else {
            Logger.error("Unsupported tween motion path data");
        }
    }
    _drawPoints(pointsData) {
        for (let i = 0; i < pointsData.length; i++) {
            const point = pointsData[i];
            const debugPoint = this.points[i] || this._createPoint().red();
            debugPoint.positionAt(point.x, point.y);
        }
    }
    _drawLine(points, curviness) {
        const rawData = points.map(p => [p.x, p.y]).flat();
        const segment = MotionPathPlugin.pointsToSegment(rawData, curviness);
        let anchorX = segment[0];
        let anchorY = segment[1];
        this.line
            .clear()
            .lineStyle(3, 0x000000)
            .moveTo(anchorX, anchorY);
        for (let i = 2; i < segment.length; i += 6) {
            let cp1x = segment[i];
            let cp1y = segment[i + 1];
            let cp2x = segment[i + 2];
            let cp2y = segment[i + 3];
            anchorX = segment[i + 4];
            anchorY = segment[i + 5];
            this.line.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, anchorX, anchorY);
        }
    }
    _createPoint() {
        const sprite = new DebugPathPoint(this);
        this.addChild(sprite);
        this.points.push(sprite);
        return sprite;
    }
    _createPath() {
        const line = new DebugPathLine();
        this.addChild(line);
        return line;
    }
    _createMotionPathData() {
        return {
            path: this.points.map(p => { return { x: p.x, y: p.y }; }),
            curviness: this.curviness,
        };
    }
    updatePath() {
        this._drawLine(this.points, this.curviness);
    }
    setCurviness(curviness) {
        this.curviness = curviness;
        this._drawLine(this.points, curviness);
    }
    logMotionData() {
        const data = this._createMotionPathData();
        data.path = data.path.map(p => { return { x: +p.x.toFixed(2), y: +p.y.toFixed(2) }; });
        console.log(JSON.stringify(data, null, 2).replace(/"([^"]+)":/g, '$1:'));
    }
    playPathTween() {
        const vars = { ...this.tween.vars, motionPath: { ...this.initialData, ...this._createMotionPathData() } };
        gsap.to(this.tween.targets(), vars);
    }
    addPoint() {
        this._createPoint().red();
        this._drawLine(this.points, this.curviness);
    }
    removePoint(index) {
        const [removed] = this.points.splice(index, 1);
        removed.destroy();
        this._drawLine(this.points, this.curviness);
    }
}
export class DebugPathPoint extends Sprite {
    constructor(path) {
        super(Texture.WHITE);
        this.path = path;
        this.isDragging = false;
        this.anchor.set(0.5, 0.5);
        this.scale.set(1.5);
        this.interactive = true;
        this.cursor = "pointer";
        this.on("pointerdown", this.startDrag);
        this.on("pointerup", this.endDrag);
        this.on("pointerupoutside", this.endDrag);
        this.on("globalmousemove", this.drag);
    }
    startDrag() {
        this.green();
        this.isDragging = true;
    }
    endDrag() {
        this.red();
        this.isDragging = false;
        this.path.updatePath();
    }
    drag(event) {
        if (this.isDragging) {
            const localPosition = this.parent.toLocal(new Point(event.globalX, event.globalY));
            this.position = localPosition;
            this.path.updatePath();
        }
    }
    red() {
        this.tint = 0xff0000;
        return this;
    }
    green() {
        this.tint = 0x00ff00;
        return this;
    }
    positionAt(x, y) {
        this.position.set(x, y);
        return this;
    }
}
export class DebugPathLine extends Graphics {
    constructor() {
        super();
    }
}
//# sourceMappingURL=DebugPath.js.map